/**
 * Copyright © Scandiweb, Inc. All rights reserved.
 *
 * @category    Puma
 * @package     Puma_SimpleSearch
 * @author      Deniss Strombergs <info@scandiweb.com>
 */

export { default } from './SimpleSearch.component';
